import styled from 'styled-components';
import Edit from '@material-ui/icons/Edit';

import THEME from '../../../../../../../constants/theme';

export const Container = styled.div``;

export const EditIcon = styled(Edit)`
  font-size: 13px !important;
  margin-left: 5px;
`;

export const EditButton = styled.div`
  display: flex;
  align-items: center;

  // NOTE: Used for align with sibling first text line(due to multiline EditInput capabilities)  
  &::before {
    content: "A";
    font-size: 13px;
    width: 0px;
    visibility: hidden;
  }
`;

export const Text = styled.div`
  display: inline;
`;

export const TextContainer = styled.div`
  display: inline-block;

  &:hover {
    background: ${THEME.lightGrey};
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const TextAlignementContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;
  padding: 2px;
`;

export const style = {
  input: {
    border      : `1px solid ${THEME.primary}`,
    borderRadius: 4,
    fontFamily  : 'Montserrat',
    fontSize    : 14,
    fontWeight  : 500,
    height      : 18,
    padding     : 0,
    paddingLeft : 3,
    width       : '100%',
  },
  multiline: {
    padding: '0',
  },
};
